export const LOGOUT = 'logout';
export const CHANGE_PASSWORD = 'change_password';
export const TOKEN = 'token';
export const TOKEN_ID = 'tokenId';
export const ADMIN = 'Admin';
export const THERAPIST = 'Therapist';

export const CYPRESS_TEST_CREATED_USER_ID_1 = '66e2a928cf9444f138526caa';

export const CYPRESS_TEST_CREATED_USER_ID_2 = '66e2e88bd0ccf6133b5954d9';
